import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-community-tips',
  templateUrl: './community-tips.component.html',
  styleUrls: ['./community-tips.component.scss']
})
export class CommunityTipsComponent {
  isFromCommunityTips: any;
  settingsData: any = {};

  constructor(public dialogRef: MatDialogRef<CommunityTipsComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
) {}

   closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnInit(){
    this.isFromCommunityTips = this.data["isFromCommunityTips"];
    this.settingsData= this.data["settingsData"];
    this.addStyle();
  }

  addStyle(){
    document.documentElement.style.setProperty('--scroll-color', this.settingsData?.form_font_secondary_color);
  }
}
